module.exports = new __parcel__URL__("pvp_defend_button_disabled.81a541da.png").toString();